import { createCtx } from "../utils/functions/createCtx";

export const [useSwitchList, SwitchListProvider] = createCtx();
